import type React from "react"
import { Outlet } from "react-router-dom"

const Offer: React.FC = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Offer
